<template>
    <div class="gc-map-control gc-map-control-bglayer"
         v-if="numLayers"
    >
        <LayerList
                :layers="layers"
                :is-expanded="isExpanded"
                v-on:layerSelected="onLayerSelected"
        ></LayerList>
        <LayerListButton
                :is-expanded="isExpanded"
                :layers="layers"
                v-on:toggleExpanded="isExpanded = !isExpanded"
        ></LayerListButton>
    </div>
</template>

<script>
    import LayerList from "./components/LayerList.vue";
    import LayerListButton from "./components/LayerListButton";

    export default {
        name: "Control",
        components: {
            LayerListButton,
            LayerList
        },
        data: function () {
            return {
                isExpanded: false
            }
        },
        computed: {
            numLayers: function () {
                let num = 0;
                if (Array.isArray(this.layers))
                {
                    this.layers.forEach(function (lyr) {
                        if (!lyr.isVoid) num++;
                    });
                }
                return num;
            }
        },
        methods: {
            onLayerSelected: function (selectedLayer) {
                if (selectedLayer)
                {
                    this.controller.showBackgroundLayer(selectedLayer);
                    this.isExpanded = false;
                }
            }
        }
    };
</script>
